import { useBreakpoint } from '../../hooks/useBreakpoint/useBreakpoint';
import { MediaItem } from '../MediaItem/MediaItem';

export interface ImageCarouselMediaItemProps {
  media: string;
  alt?: string;
  placeholderSrc?: string;
  objectFit?: 'contain' | 'cover';
  omitPadding?: boolean;
}

export const ImageCarouselMediaItem = ({
  media,
  alt,
  placeholderSrc,
  objectFit,
  omitPadding,
}: ImageCarouselMediaItemProps) => {
  const { isMobile } = useBreakpoint();

  return (
    <MediaItem
      key={`media-${media}`}
      media={media}
      alt={alt}
      slotProps={{
        image: {
          placeholderSrc,
          rounded: false,
          showLoader: true,
          sx: {
            display: 'block',
            height: '50dvh',
            maxWidth: '100dvw',
            objectFit,
            padding: omitPadding ? 0 : 2,
            width: '100%',
          },
        },
        video: {
          autoPlay: true,
          controls: true,
          loop: true,
          muted: true,
          playsInline: true,
          sx: {
            height: '50dvh',
            maxWidth: '100dvw',
            objectFit,
            width: isMobile ? '100%' : '50dvw',
          },
        },
      }}
    />
  );
};
